<template>
    <div class="campaign-box campaign-box--no-top-border campaign-box--top-padding">
        <div class="col-md-12 text-center" v-if="loading">
            <i class="fa fa-spinner fa-spin inner-loading"></i>
        </div>

        <form v-on:submit.prevent="submitForm" data-dusk="ready" ref="cardForm" method="post" v-else>
            <validation-errors :errors="errors"></validation-errors>

            <div class="row">
                <div class="col-sm-4">
                    <h4>Funding Source</h4>

                    <p class="p-b-lg text-muted">
                        Choose "New Card" to add a credit card; select a credit card and press the "Delete" button at the bottom of this form to remove a credit card.
                    </p>
                </div>

                <div class="col-sm-8">
                    <div class="form-group">
                        <label class="control-label">Select Funding Source</label>

                        <div>
                            <select class="form-control" data-dusk="fundingSourceId" v-model="fundingSourceId">
                                <option value="">New Card</option>
                                <option :value="fundingSource.id" v-for="fundingSource in fundingSources">{{ fundingSource.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div class="row" v-if="isCreatingNewCard">
                <div class="col-sm-4">
                    <h4>Credit Card Information</h4>
                </div>

                <div class="col-sm-8">
                    <div class="form-group" v-validation-field:cardAlias="errors">
                        <label class="control-label">Card Nickname</label>

                        <div>
                            <input type="text" class="form-control" placeholder="Card Nickname" v-model="card.cardAlias" data-dusk="cardAlias" name="USER1" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-group" v-validation-field:cardName="errors">
                        <label class="control-label">Name on Card</label>

                        <div>
                            <input type="text" class="form-control fs-block" placeholder="Name on Card" v-model="card.cardName" data-dusk="cardName" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-6 form-group" v-validation-field:cardNumber="errors">
                            <label class="control-label">Card Number</label>
                            <input type="text" class="form-control fs-block" placeholder="Card Number" v-model="card.cardNumber" data-dusk="cardNumber" name="ACCT" autocomplete="off">
                        </div>

                        <div class="col-sm-6 form-group" v-validation-field:cardCvv="errors">
                            <label class="col-sm-2 control-label">CSC</label>
                            <input type="text" class="form-control fs-block" placeholder="CSC" v-model="card.cardCvv" data-dusk="cardCvv" name="CVV2" autocomplete="off">
                        </div>
                    </div>

                    <div class="form-group" v-validation-field:cardType="errors">
                        <label class="control-label">Card Type</label>

                        <div>
                            <select class="form-control" v-model="card.cardType" data-dusk="cardType" name="cardType">
                                <option :value="cardType.id" v-for="cardType in cardTypes">{{ cardType.label }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group" v-validation-field:cardExpiry="errors">
                        <label class="control-label">Exp Date</label>

                        <div>
                            <div class="row">
                                <div class="col-xs-3" v-validation-field:cardExpiryMonth="errors">
                                    <select class="form-control col-sm-2 fs-block" v-model="card.cardExpiryMonth" data-dusk="cardExpiryMonth" name="cardExpiryMonth">
                                        <option value="01" select>January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                </div>

                                <div class="col-xs-3" v-validation-field:cardExpiryYear="errors">
                                    <select class="form-control fs-block" v-model="card.cardExpiryYear" data-dusk="cardExpiryYear" name="cardExpiryYear">
                                        <option v-for="year in years">{{ year }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="isCreatingNewCard">

            <div class="row" v-if="isCreatingNewCard">
                <div class="col-sm-4">
                    <h4>Billing Information</h4>
                </div>

                <div class="col-sm-8">
                    <div class="form-group" v-validation-field:billingAddress1="errors">
                        <label class="control-label">Address</label>

                        <div>
                            <input type="text" class="form-control fs-block" placeholder="Address" v-model="card.billingAddress1" data-dusk="billingAddress1" name="BILLTOSTREET">
                        </div>
                    </div>

                    <div class="form-group" v-validation-field:billingAddress2="errors">
                        <label class="control-label">Address 2 <small>(optional)</small></label>

                        <div>
                            <input type="text" class="form-control fs-block" placeholder="Address 2" v-model="card.billingAddress2" data-dusk="billingAddress2" name="BILLTOSTREET2">
                        </div>
                    </div>

                    <div class="form-group" v-validation-field:billingCity="errors">
                        <label class="control-label">City</label>

                        <div>
                            <input type="text" class="form-control fs-block" placeholder="City" v-model="card.billingCity" data-dusk="billingCity" name="BILLTOCITY">
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-5" v-validation-field:billingState="errors">
                            <label class="control-label">State</label>

                            <select class="form-control fs-block" v-model="card.billingState" data-dusk="billingState" name="BILLTOSTATE">
                                <option disabled value="">Select State</option>
                                <option value="AL">Alabama</option>
                                <option value="AK">Alaska</option>
                                <option value="AS">American Samoa</option>
                                <option value="AZ">Arizona</option>
                                <option value="AR">Arkansas</option>
                                <option value="CA">California</option>
                                <option value="CO">Colorado</option>
                                <option value="CT">Connecticut</option>
                                <option value="DE">Delaware</option>
                                <option value="DC">District Of Columbia</option>
                                <option value="FM">Federated States Of Micronesia</option>
                                <option value="FL">Florida</option>
                                <option value="GA">Georgia</option>
                                <option value="GU">Guam</option>
                                <option value="HI">Hawaii</option>
                                <option value="ID">Idaho</option>
                                <option value="IL">Illinois</option>
                                <option value="IN">Indiana</option>
                                <option value="IA">Iowa</option>
                                <option value="KS">Kansas</option>
                                <option value="KY">Kentucky</option>
                                <option value="LA">Louisiana</option>
                                <option value="ME">Maine</option>
                                <option value="MH">Marshall Islands</option>
                                <option value="MD">Maryland</option>
                                <option value="MA">Massachusetts</option>
                                <option value="MI">Michigan</option>
                                <option value="MN">Minnesota</option>
                                <option value="MS">Mississippi</option>
                                <option value="MO">Missouri</option>
                                <option value="MT">Montana</option>
                                <option value="NE">Nebraska</option>
                                <option value="NV">Nevada</option>
                                <option value="NH">New Hampshire</option>
                                <option value="NJ">New Jersey</option>
                                <option value="NM">New Mexico</option>
                                <option value="NY">New York</option>
                                <option value="NC">North Carolina</option>
                                <option value="ND">North Dakota</option>
                                <option value="MP">Northern Mariana Islands</option>
                                <option value="OH">Ohio</option>
                                <option value="OK">Oklahoma</option>
                                <option value="OR">Oregon</option>
                                <option value="PW">Palau</option>
                                <option value="PA">Pennsylvania</option>
                                <option value="PR">Puerto Rico</option>
                                <option value="RI">Rhode Island</option>
                                <option value="SC">South Carolina</option>
                                <option value="SD">South Dakota</option>
                                <option value="TN">Tennessee</option>
                                <option value="TX">Texas</option>
                                <option value="UT">Utah</option>
                                <option value="VT">Vermont</option>
                                <option value="VI">Virgin Islands</option>
                                <option value="VA">Virginia</option>
                                <option value="WA">Washington</option>
                                <option value="WV">West Virginia</option>
                                <option value="WI">Wisconsin</option>
                                <option value="WY">Wyoming</option>
                            </select>
                        </div>

                        <div class="col-sm-5" v-validation-field:billingPostCode="errors">
                            <label class="control-label">Zip</label>

                            <input type="text" class="form-control fs-block" placeholder="Zip" v-model="card.billingPostCode" data-dusk="billingPostCode" name="BILLTOZIP">
                        </div>

                        <div class="col-sm-2">
                            <label class="control-label">Country</label>

                            <select class="form-control" disabled>
                                <option>USA</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-else>
                <div class="col-sm-4">
                    <h4>Card Preview</h4>
                </div>

                <div class="col-sm-8">
                    <card-preview :funding-source="selectedSource"></card-preview>
                </div>
            </div>

            <hr>

            <div class="row --edit">
                <div class="col-sm-12">
                    <button class="btn btn-success pull-right" :class="{disabled: saving}" data-dusk="save" v-if="isCreatingNewCard">Add Card</button>

                    <div v-else>
                        <button class="btn btn-warning pull-right" :class="{disabled: saving}" data-dusk="delete">Delete Card</button>
                    </div>
                </div>
            </div>
            <div class="hidden">
                <!-- Hidden fields for Paypal -->
                <input type="hidden" name="SECURETOKEN" :value="transactionDetails.secureToken" />
                <input type="hidden" name="SECURETOKENID" :value="transactionDetails.secureTokenId" />
                <input type="hidden" name="BILLTOFIRSTNAME" :value="card.cardFirstName" />
                <input type="hidden" name="BILLTOLASTNAME" :value="card.cardLastName" />
                <input type="hidden" name="TRXTYPE" :value="transactionDetails.trxType" />
                <input type="hidden" name="TENDER" :value="transactionDetails.tender" />
                <input type="hidden" name="EXPDATE" :value="card.expDate" />
            </div>
        </form>
    </div>
</template>

<script type="text/babel">
import ValidationErrors from './../utils/validation-errors.vue';
import CardPreview from './card-preview.vue';
import ValidationField from './../../directives/validation-field';
import moment from 'moment';
import Swal from "sweetalert2";

export default {
    components: {
        'validation-errors': ValidationErrors,
        'card-preview': CardPreview
    },

    directives: { 'validation-field': ValidationField },

    props: {
        loading: Boolean,
        fundingSources: Array,
        cardTypes: Array,
        paymentPlans: Array,
        fundsPools: Array,
        payflowLinkUrl: String
    },

    data() {
        return {
            saving: false,
            errors: {},
            fundingSourceId: '',
            card: {
                cardAlias: '',
                cardName: '',
                cardFirstName: '',
                cardLastName: '',
                cardNumber: '',
                cardCvv: '',
                cardType: 1,
                cardExpiryMonth: '01',
                cardExpiryYear: (new Date).getFullYear(),
                billingAddress1: '',
                billingAddress2: '',
                billingCity: '',
                billingState: '',
                billingPostCode: '',
            },
            transactionDetails: {
                secureToken: null,
                secureTokenId: null,
                trxType: 'A',
                tender: 'C',
            }
        }
    },

    computed: {
        years() {
            let years = [];

            let currentYear = (new Date).getFullYear();

            for (var i=currentYear; i < currentYear+20; i++) {
                years.push(i);
            }

            return years;
        },

        isCreatingNewCard() {
            return this.fundingSourceId === '';
        },

        selectedSource() {
            return _(this.fundingSources).find({id: this.fundingSourceId});
        }
    },

    methods: {
        submitForm() {
            console.log('submitForm handler');
            console.log(process.env.MIX_API_FUNDING_V2_ENDPOINT + '/secure-token');
            this.isCreatingNewCard
                ? this.fetchSecureToken()
                : this.warnAboutDestruction() ;
        },

        splitNames(name) {
            let namesArray = name.split(' ');
            return {
                firstName: namesArray[0],
                lastName: namesArray[namesArray.length - 1]
            }
        },

        sanitizeCard(card) {
            return {
                cardAlias: card.cardAlias,
                cardName: card.cardName,
                billingAddress1: card.billingAddress1,
                billingAddress2: card.billingAddress2,
                billingCity: card.billingCity,
                billingState: card.billingState,
                billingPostCode: card.billingPostCode,
            };
        },

        fetchSecureToken() {
            console.log('fetchSecureToken fired');
            const data = {
                returnUrl: `${route('billing-setup.funding-source.store')}`,
                errorUrl: `${route('billing-setup.funding-source.store')}`,
            };
            console.log(data);
            document.cookie = `Payflow=${process.env.MIX_PAYFLOW_LINK_URL}--env:${process.env.APP_ENV}---${JSON.stringify(data)}`;
            this.$http.post(`${route('billing-setup.funding-source.generateSecureToken')}`, data).then(response => {
                console.log('post succeeded');
                this.transactionDetails.secureToken = response.body.secureToken;
                this.transactionDetails.secureTokenId = response.body.secureTokenId;
                this.saving = true;

                this.prepareAndSendForm();
            }).catch(({ status, data }) => {
                console.log('post failed');

                if (status === 422) {
                    this.errors = data.errors;
                } else if (data.message && data.success === false) {
                    this.errors = {message: [data.message]};
                } else {
                    new Swal('Whoops!', 'Something went wrong. Please contact support.', 'error');
                }

                this.saving = false;
            });
        },

        prepareAndSendForm() {
            const payFlowUrl = process.env.MIX_PAYFLOW_LINK_URL || 'https://payflowlink.paypal.com';
            document.cookie = `payFlowUrl=${payFlowUrl}`;
            this.card.cardFirstName = this.splitNames(this.card.cardName).firstName;
            this.card.cardLastName = this.splitNames(this.card.cardName).lastName;
            this.card.expDate = moment(`${this.card.cardExpiryMonth}/01/${this.card.cardExpiryYear}`).format('MMYY');
            this.$refs.cardForm.setAttribute('action', payFlowUrl);

            this.$nextTick(() => {
                this.$refs.cardForm.submit();
            });
        },

        showConfirmMessage: function(text, callback) {
            const args = {
                title: 'Are you sure?',
                html: text,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            };

            new Swal(args).then((response) => {
                if (typeof callback != 'undefined') {
                    if (response.isConfirmed) {
                        callback();
                    }
                }
            }).catch();
        },

        warnAboutDestruction()
        {
            if (this.saving) {
                return;
            }

            let implicatedPaymentPlan = this.paymentPlans.find(plan => { return plan.fundingSourceId === this.fundingSourceId });

            if (implicatedPaymentPlan) {
                let fundsPool = this.fundsPools.find(fundsPool => { return fundsPool.id === implicatedPaymentPlan.fundsPoolId });
                let warning = `Deleting this funding source will change your payment plan for ${fundsPool.name} to pay-as-you-go. Do you want to continue?`

                this.showConfirmMessage(warning, this.destroy);
            } else {
                this.destroy();
            }
        },

        destroy() {
            this.saving = true;

            console.log('destroy');
            this.$http.delete(route('billing-setup.funding-source.destroy', {id: this.fundingSourceId}))
                .then(() => {
                    sweetAlert.fire(
                        'Success',
                        'Card Deleted!',
                        'success'
                    ).then(() => {
                        this.$emit('refreshStep');
                    });
                }).catch(({ status, data }) => {
                if (status === 422) {
                    this.errors = data.errors;
                } else if (data.message && data.success === false) {
                    this.errors = {message: [data.message]};
                } else {
                    new Swal('Whoops!', 'Something went wrong. Please contact support.', 'error');
                }

                this.saving = false;
            });
        }
    }
}
</script>
